<script>
/**
 * Create component is a recursive function that takes a DOM structure
 * and a rendering function (of vue.js) and returns a Vuejs component.
 */
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';

const createComponent = (element, h) => {
  // Handle empty elements and return empty array in case the element passed in is empty
  if (isEmpty(element)) {
    return [];
  }

  // if the element is array call createComponent for all element children
  if (isArray(element)) {
    return element.map(child => createComponent(child, h));
  }

  const children = [];

  if (element.children && element.children.length > 0) {
    element.children.forEach((child) => {
      if (isString(child)) {
        children.push(child);
      } else {
        children.push(createComponent(child, h));
      }
    });
  }

  return h(element.type, element.data, children.length > 0 ? children : null);
};

export default {
  name: 'pb-elements',

  props: {
    element: {
      type: Object,
      required: true,
    },
  },

  render(h) {
    return createComponent(this.element, h);
  },
};
</script>
